import { useState } from "react";
import type { BobState } from "../types";
import { planMerge } from "../lib/engine/mergePlanner";

interface Props {
  state: BobState;
  onUpdate: (partial: Partial<BobState>) => void;
  toast: (msg: string) => void;
}

export function MergePlannerPanel({ state, onUpdate, toast }: Props) {
  const [labelA, setLabelA] = useState("Existing same-disk BOB");
  const [pathA, setPathA] = useState("/Volumes/Avolusion/Github Babies/_BOB_UPGRADE_OUT/located_sources/bob-arkmpyre");
  const [notesA, setNotesA] = useState("Vite React CF Pages deploy, local-first sovereign runtime, no API keys");
  const [labelB, setLabelB] = useState("BoB Builder ZIP bundle");
  const [pathB, setPathB] = useState("/Volumes/Avolusion/Github Babies/BoB Builder.zip");
  const [notesB, setNotesB] = useState("Audit staging bundle: lovable clone, agent-zero, prompts, builder patterns");
  const latest = state.mergePlans[state.mergePlans.length - 1];

  function runMergePlan() {
    const plan = planMerge({ labelA, pathA, notesA, labelB, pathB, notesB });
    onUpdate({ mergePlans: [...state.mergePlans, plan] });
    toast(`Merge plan: base=${plan.base}, salvage=${plan.salvage}`);
  }

  return (
    <section className="surface glass-panel">
      <h2>Merge / Upgrade Planner</h2>
      <p className="lead">Compare source A vs B — base/salvage decision and patch checklist.</p>
      <div className="form-grid">
        <label>
          Source A label
          <input value={labelA} onChange={(e) => setLabelA(e.target.value)} />
        </label>
        <label>
          Source A path
          <input value={pathA} onChange={(e) => setPathA(e.target.value)} />
        </label>
        <label>
          Source A notes
          <textarea value={notesA} onChange={(e) => setNotesA(e.target.value)} />
        </label>
        <label>
          Source B label
          <input value={labelB} onChange={(e) => setLabelB(e.target.value)} />
        </label>
        <label>
          Source B path
          <input value={pathB} onChange={(e) => setPathB(e.target.value)} />
        </label>
        <label>
          Source B notes
          <textarea value={notesB} onChange={(e) => setNotesB(e.target.value)} />
        </label>
      </div>
      <div className="btn-row">
        <button type="button" className="btn gold" onClick={runMergePlan}>
          Generate merge plan
        </button>
      </div>
      {latest && (
        <pre className="output-box">
          {`BASE: ${latest.base}\nSALVAGE: ${latest.salvage}\n\nFeature transfer:\n${latest.featureTransfer.map((f) => `- ${f}`).join("\n")}\n\nConflicts:\n${latest.conflictFlags.map((f) => `- ${f}`).join("\n") || "- none"}\n\nRisks:\n${latest.riskFlags.map((f) => `- ${f}`).join("\n") || "- none"}\n\nPatch steps:\n${latest.patchSteps.map((s, i) => `${i + 1}. ${s}`).join("\n")}`}
        </pre>
      )}
    </section>
  );
}
